import type { ComponentProps } from 'react'
import _PriceRowPrice from './_PriceRowPrice'

type InheritedBasePriceRowPrice = Pick<ComponentProps<typeof _PriceRowPrice>, 'discountPercentage' | 'discountType' | 'price' | 'saleUnit' | 'signDisplay' | 'size' | 'wrap'>
type RequiredBasePriceRowPrice = Required<Pick<ComponentProps<typeof _PriceRowPrice>, 'caption'>>

interface Props extends InheritedBasePriceRowPrice, RequiredBasePriceRowPrice, Utils.PropsWithDataAttributes {
}

/**
 * Displays a formatted price with a leading caption and a trailing sale unit.
 */
function PriceRowPriceWithCaption(props: Props) {
  return <_PriceRowPrice {...props} />
}

export default PriceRowPriceWithCaption
